<template>
  <div class="CadastroConfigFuncao">
      <el-button v-if="permissao.editar_configuracoes"
      style="float: right; padding: 5px 5px"
      @click="dialogFormVisible = true"
      icon="el-icon-circle-plus"
      type="primary"
      plain
      round
    >Nova Função</el-button>
            <el-table :data="listFuncoes" empty-text="Sem dados!">
              <el-table-column width="100" property="id" label="Cód."></el-table-column>
              <el-table-column  property="funcao" label="Função"></el-table-column>
              <el-table-column  property="carga_horaria" label="Carga Horária"></el-table-column>



              <!-- <el-table-column  property="carga_horaria" label="Carga Horária" width="150">
                <template slot-scope="scope">
                  <money  v-model="listFuncoes[scope.$index].carga_horaria" v-bind="percentual" class="el-input el-input__inner"></money> 
                </template>
              </el-table-column> -->



              <el-table-column prop="acao" label="Ação" filter-placement="bottom-end">
                <template slot-scope="scope">
                  <el-button-group>
                    <!-- <el-tooltip v-if="permissao.editar_configuracoes" class="item" effect="light" content="Editar" placement="top">
                      <el-button
                        size="mini"
                        type="primary"
                        @click="handleDeleteFuncao2(scope.$index, scope.row)"
                      >Salvar</el-button>
                    </el-tooltip> -->
                    <el-tooltip v-if="permissao.excluir_configuracoes" class="item" effect="light" content="Excluir" placement="top">
                      <el-button
                        size="mini"
                        type="danger"
                        @click="handleDeleteFuncao(scope.$index, scope.row)"
                        icon="el-icon-delete"
                      ></el-button>
                    </el-tooltip>
                  </el-button-group>
                </template>
              </el-table-column>
            </el-table>


    <!-- DIALOG DE CADASTRO DE FUNÇÃO -->
    <el-dialog title="Nova Função" :visible="dialogFormVisible" :show-close="false">
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        :label-position="labelPosition"
        class="demo-ruleForm"
      >
        <el-form-item label="Função" prop="funcao">
          <el-input v-model="ruleForm.funcao" ></el-input>
        </el-form-item>
        <el-form-item label="Carga Horária" prop="carga_horaria">
          <el-input v-model.lazy="ruleForm.carga_horaria" v-money="money">
            <template slot="prepend">R$</template>
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleFechar()">Cancelar</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')">Salvar</el-button>
      </span>
    </el-dialog> 
  </div>
</template>
<script>
import axios from "axios";
import FuncoesUteis from "../../plugins/FuncoesUteis";
import {VMoney} from 'v-money';

// const url = "http://" + window.location.hostname + ":8000/api";
const url = '/api';

export default {
  directives: {money: VMoney},
  data() {
    return {
       money: {
          decimal: ',',
          thousands: '.',
        //  prefix: 'R$ ',
         //suffix: ' #',
          precision: 2,
          masked: false /* doesn't work with directive */
        },
      labelPosition: "right",
      dialogFormVisible: false,
      listFuncoes:[],
      permissao: {},
      ruleForm: {
        funcao: "",
        carga_horaria: "",
      },
      rules: {
        funcao: [
          {
            required: true,
            message: "Informe a Função",
            trigger: "blur",
          },
        ],        
        carga_horaria: [
          {
            required: true,
            message: "Informe o valor da Carga Horária",
            trigger: "blur",
          },
        ],
      },
    };
  },
  mounted() {
    this.permissao = FuncoesUteis.isPermissao();
    if (!this.permissao.ler_configuracoes) {
      this.$message.error("Você não tem permissão para acessar esta página.");
      this.$router.push("/");
      return;
    }
    axios
      .get(url + "/config_funcoes", {
        headers: {
          Authorization: "Bearer " + this.$store.state.token,
        },
      })
      .then((response) => {
        if (response.data.status == "Token is Expired" || response.data.status == "Token is Invalid" || response.data.status == "Authorization Token not found") {
          this.$store.dispatch("logout").then(() => {
            this.$router.push("/login");
          });
        } else {
          this.listFuncoes = response.data;

          this.loading = false;
        }
      })
      .catch((err) => {
        this.total = "erro" + err;
      });
  
  
  },  
  methods: {
      formatter(row) {
        let vl = new String(row.carga_horaria);
        vl = vl.replace(",", "");
        vl = vl.replace(".", ",");
        return vl;
      },

    getDadosFuncao: function () {
      axios
        .get(url + "/config_funcoes", {
          headers: {
            Authorization: "Bearer " + this.$store.state.token,
          },
        })
        .then((response) => {
          if (response.data.status == "Token is Expired" || response.data.status == "Token is Invalid" || response.data.status == "Authorization Token not found") {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            this.listFuncoes = response.data; 
            this.loading = false;
          }
        })
        .catch((err) => {
          this.total = "erro" + err;
        });
    },    
    //CADASTRO DADOS
    handleFechar() {
      this.$confirm("Tem certeza que deseja sair?", "Aviso", {
        confirmButtonText: "Sim",
        cancelButtonText: "Não",
        type: "warning",
      })
        .then(() => {
          this.dialogFormVisible = false;
          this.ruleForm.carga_horaria = "";
          this.ruleForm.funcao = "";
        })
        .catch(() => {
          this.dialogFormVisible = true;
        });
    },

    submitForm(formName) {

      this.$refs[formName].validate((valid) => {
        if (valid) {
               let vl;
               vl = this.ruleForm.carga_horaria;
               vl = vl.replace('.','');
               this.ruleForm.carga_horaria = vl.replace(',','.');
          let dados = {
            carga_horaria: this.ruleForm.carga_horaria,
            funcao: this.ruleForm.funcao,
          };
          axios
            .post(url + "/config_funcoes/", dados, {
              headers: {
                Authorization: "Bearer " + this.$store.state.token,
              },
            })
            .then(() => {
              this.$notify({
                title: "Sucesso",
                message: "Registro Salvo com sucesso!",
                type: "success",
              });
              this.dialogFormVisible = false;
              this.ruleForm.carga_horaria = "0";
              this.ruleForm.funcao = "";
              this.getDadosFuncao();
            })
            .catch((err) => {
              this.$notify({
                title: "Erro",
                message:
                  "Erro ao cadastrar os dados! Tente novamente mais tarde!" +
                  err,
                type: "error",
              });
              this.dialogFormVisible = false;
              this.ruleForm.carga_horaria = "";
              this.ruleForm.funcao = "";
            });
        } else {
          this.$message({
            type: "info",
            message: "Informe os dados corretamente!",
          });
          return false;
        }
      });
    },
    //FIM CADASTRO DADOS
    //EXCLUIR DADOS RENTABILIDADE
    handleDeleteFuncao(index, row) {
      this.$confirm("Tem certeza que deseja excluir este registro?", "Aviso", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancelar",
        type: "warning",
      })
        .then(() => {
          axios
            .delete(url + "/config_funcoes/" + row.id, {
              headers: {
                Authorization: "Bearer " + this.$store.state.token,
              },
            })
            .then(() => {
              //this.itens = response.data;
              this.$notify({
                title: "Sucesso",
                message: "Registro excluído com Sucesso!",
                type: "success",
              });
              this.getDadosFuncao();
            })
            .catch((err) => {
              this.$notify({
                title: "Erro",
                message:
                  "Erro ao excluir os dados! Tente novamente mais tarde!" + err,
                type: "error",
              });
            });
        })
        .catch(() => {});
    },
    //FIM EXCLUIR DADOS COMISSÃO    
  },
};
</script>